<template>
  <div class="splitpane__pane" :style="dynamicStyle">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'StdPane',
    props: {
      size: {
        type: [Number, String]
      }
    },
    computed: {
      dynamicStyle() {
        if (this.size) {
          return {
            [this.$parent.horizontal ? 'height' : 'width']: this.size
          };
        }
        return null;
      }
    }
  };
</script>
